import { render, staticRenderFns } from "./HistoricalNoteInfoModal.vue?vue&type=template&id=5b58d9ec&scoped=true&"
import script from "./HistoricalNoteInfoModal.vue?vue&type=script&lang=ts&"
export * from "./HistoricalNoteInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricalNoteInfoModal.vue?vue&type=style&index=0&id=5b58d9ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b58d9ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VExpansionPanels,VIcon})
